import React, { useEffect, useState } from "react";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { kbdEvent } from "../utils/Utils";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import SetupPasswords from "./SetupPasswords";
import SetupTaxCodes from "./SetupTaxCodes";
import PrinterSettings from "./PrinterSettings";
import SetupPOS from "./SetupPOS";

export default function Setup(props) {

    const { controller = "", signal = {}, callback = () => { }, route = "" } = props;

    const [selected, setSelected] = useState("General");
    const settings = [
        { key: KBD.A, text: "General" },
        { key: KBD.B, text: "Ordering" },
        { key: KBD.C, text: "Returns" },
        { key: KBD.D, text: "Customer and A/R" },
        { key: KBD.E, text: "Receiving" },
        { key: KBD.F, text: "POS (Point-of-sale)", action : () => { drawPOSSettings()} },
        { key: KBD.G, text: "POS Invoice Format" },
        { key: KBD.H, text: "Month end" },
        { key: KBD.I, text: "Printers", action : () => {drawPrinterSettings()} },
        { key: KBD.J, text: "Tax Tables", action: () => { drawTaxCodes() } },
        { key: KBD.K, text: "Faxing" },
        { key: KBD.L, text: "eMail" },
        { key: KBD.M, text: "Keyword searching fields" },
        { key: KBD.N, text: "Tools (@Function keys)" },
        { key: KBD.O, text: "System date & time" },
        { key: KBD.P, text: "Multi-store" },
        { key: KBD.Q, text: "Your Company Name, etc." },
        { key: KBD.R, text: "Color preference." },
        { key: KBD.S, text: "Passwords & Clerk Codes", action: (e) => { drawSetupPasswords() } },
        { key: KBD.T, text: "Frequent Buyer Points" },
        { key: KBD.U, text: "Gift Cards" },
        { key: KBD.V, text: "WebStore" },
        { key: KBD.W, text: "Weblink server" },
        { key: KBD.X, text: "PubStock" },
        { key: KBD.Y, text: "Stock conditions" },
        { key: KBD.Z, text: "Credit Card Security" },
        { key: KBD.Digit1, text: "Used book settings" },
        { key: KBD.Digit2, text: "QuickBooks settings" }
    ];

    const handleEnter = (_s = "") => {
        let _f = settings.find(item => item.text === _s);
        if (_f) {
            setTimeout(() => { kbdEvent(_f.key); }, 50)
        }
    }

    const drawPrinterSettings = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.PRINTER_SETTINGS;
        createModal({
            component: <PrinterSettings controller={controller} signal={signal} route={ROUTES.GLOBAL.PRINTER_SETTINGS} />, closable: true, title: "Setup Printers", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawPOSSettings = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP_POS;
        createModal({
             component: <SetupPOS controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP_POS} />, closable: true, title: "Point-of-Sale - Setup", callback: () => {
                window.bm_state.value = origin;
            } 
        })
    }

    const drawTaxCodes = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP_TAXCODES;
        createModal({
            component: <SetupTaxCodes controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP_TAXCODES} />, closable: true, title: "Tax Setup", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    const drawSetupPasswords = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.GLOBAL.SETUP_PASSWORDS;
        createModal({
            component: <SetupPasswords controller={controller} signal={signal} route={ROUTES.GLOBAL.SETUP_PASSWORDS} />, closable: true, title: "Passwords & Clerk Codes", callback: () => {
                window.bm_state.value = origin;
            }
        })
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ENTER, action: (e) => { handleEnter(selected) } },
        ];
        const cleanup = listen(controller, route, actions.concat(settings), false);
        return cleanup;
    }, [selected]);


    return (
        <>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} columns={2} callback={(e) => { kbdEvent(e.key) }} show_keys bordered keyName="text" selected={selected} setSelected={setSelected} menu={settings} route={route} />
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon /></Status>
        </>
    )
}